import BUTTONGROUP, { BUTTON } from '../../DOM/GROUP/buttongroup/BUTTONGROUP.js';
import Closeable, { Close, Open } from '../../../interface/Closeable.js';
import FLEXVERTICAL from '../../COMPONENT/flex/FLEXVERTICAL.js';
import NAVFOOTER from '../../DOM/nav/navbar/navfooter/NAVFOOTER.js';
import NAVHEADER from '../../DOM/nav/navbar/navheader/NAVHEADER.js';
import Selectable from '../../../interface/Selectable.js';
import EL from '../../EL/EL.js';
import { HTMLELEMENT, text } from '../../DOM/text/TEXT.js';
import { makeAttrStruct } from '../../../enums/ModelAttr.js';
import { makeStruct } from '../../../enums/MODELS.js';
import { makeDataStruct } from '../../../enums/ModelData.js';
import { button } from '../../DOM/button/BUTTON.js';
import DIV, { div } from '../../DOM/div/DIV.js';
import { icon } from '../../SVG/icon/ICON.js';
import { span } from '../../DOM/span/SPAN.js';
import { SVGS } from '../../SVG/SVGS.js';
import Deactivate from '../../../event/Deactivate.js';
import { textBlock } from '../../DOM/div/TEXTBLOCK/TEXTBLOCK.js';
// Model Structure
export const dialogAttr = makeAttrStruct([
    ['name'],
    ['class'],
    ['open'],
    ['closeOnFocusOut', false]
]);
export const dialogData = makeDataStruct([
    ['caller'],
    ['text', text()],
    ['header', {}],
    ['footer', {}]
]);
export const dialogModel = makeStruct([
    ['attributes', dialogAttr],
    ['data', dialogData],
    ['meta', () => ({})] // default meta
]);
// Simplified Model
export function dialog(caller, name, text, header, footer) {
    return {
        attributes: dialogAttr(name),
        data: dialogData(caller, text, header, footer)
    };
}
/** Constructs a DIALOG Element */
export default class DIALOG extends EL {
    // public override node!: BODY<BodyElementModel>; // Explicitly declare the node type
    caller;
    flexvertical;
    header;
    btnClose;
    content;
    // public btnIcon: BUTTON<ButtonElementModel>;
    footer;
    constructor(node, model) {
        super(node, HTMLELEMENT.DIALOG, model);
        this.implement(new Closeable(this));
        this.implement(new Selectable(this));
        this.show = () => this.showModal();
        this.close = () => this.closeDialog();
        this.hide = () => this.hideDialog();
        this.caller = model.data.caller;
        this.transitionSpeed = 100;
        this.flexvertical = new FLEXVERTICAL(this, div());
        this.header = new NAVHEADER(this.flexvertical.top, model.data.header);
        this.btnClose = this.header.navRight.addButton(button(span('Close'), 'btn-close', icon(SVGS.CLOSE), 'Close Dialog')).on('click', () => this.closeDialog());
        this.content = new DIV(this.flexvertical.middle, div('content'));
        this.textBlock = this.content.addTextblock(textBlock('text')).addSpan(model.data.text);
        this.footer = new NAVFOOTER(this.flexvertical.bottom, model.data.footer);
        if (model.attributes.closeOnFocusOut) {
            this.closeOnFocusOut();
        }
    }
    /** When DIALOG loses focus, it will be closed */
    closeOnFocusOut() {
        this.el.addEventListener('click', (e) => {
            const rect = this.flexvertical.el.getBoundingClientRect();
            // If click is outside of dialog content box, close it
            if (e.clientX < rect.left ||
                e.clientX > rect.right ||
                e.clientY < rect.top ||
                e.clientY > rect.bottom) {
                this.closeDialog();
            }
        });
    }
    /** Shows the DIALOG
        @param delay Millisecond delay until dialog is shown
        @returns Callback on successful display of dialog
    */
    showModal(delay = 0) {
        console.log('showModal', this);
        return this.chain(() => setTimeout(() => {
            this.el.showModal();
            this.removeClass('hiding');
        }, delay));
    }
    /** Closes the DIALOG by hiding it and then removing it from the DOM
        @param delay Millisecond delay until dialog is closed
        @returns {Promise} Callback on successful close
    */
    closeDialog(delay = this.transitionSpeed) {
        console.log('closeDialog', this);
        return this.hideDialog(delay, false);
    }
    /** Hides the DIALOG and deactivates its caller
        @param delay Millisecond delay until dialog is closed (Imports transition speed)
        @param preserve If true, element is not deleted
        @returns Callback on successful close
    */
    hideDialog(delay = this.transitionSpeed, preserve = true) {
        console.log('hideDialog', this);
        return new Promise((resolve, reject) => {
            try {
                this.addClass('hiding');
                setTimeout(() => {
                    this.el.close();
                    if (preserve) {
                        resolve(this);
                    }
                    else {
                        this.destroy().then(() => {
                            this.deactivateCaller();
                            resolve(this);
                        });
                    }
                }, delay);
            }
            catch (e) {
                reject(e);
            }
        });
    }
    /** Deactivates DIALOG caller if exists */
    deactivateCaller() {
        if (this.caller !== null && this.caller.hasClass('active')) {
            try {
                this.caller.do(new Deactivate());
            }
            catch (e) {
                console.warn('Unable to deactivate caller', this.caller.toString(), e);
            }
        }
    }
    /** Dispatches a close event to all other DIALOGS */
    closeActiveDialogs() {
        // deactivate any active dialogs that arent this dialog
        let activeDialogs = document.getElementsByClassName('.dialog.in');
        for (let t = 0; t < activeDialogs.length; t++) {
            if (activeDialogs[t] === this.el) {
                console.log('No need to deactivate this');
            }
            else {
                activeDialogs[t].dispatchEvent(new Close()); //activeDialogs[t]
            }
        }
    }
    getBody() {
        return this.node;
    }
}
export { BUTTON, BUTTONGROUP, Close, DIV, EL, NAVHEADER, NAVFOOTER, Open };
